import React from 'react';

const ERR_NO_SPACE = '101';
const ERR_PAYMENT_GATEWAY = '102';
const ERR_BAD_PAYMENT_ID = '103';
const ERR_INVALID_DATE = '104';
const ERR_CLOSING_TIME = '105';

const CREATED = 'CREATED';
const PAYMENT_METHOD_CHOSEN = 'PAYMENT_METHOD_CHOSEN';
const PAID = 'PAID';
const AUTHORIZED = 'AUTHORIZED';
const CANCELED = 'CANCELED';
const TIMEOUTED = 'TIMEOUTED';
const REFUNDED = 'REFUNDED';
const PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED';
const FAILED = 'FAILED';

const NO_GATE = 'NO_GATE';

const ERROR = 'ERROR';


const getTitles = () => ({
	[ERR_PAYMENT_GATEWAY]: 'enums.ReservationStatus.titles.errPaymentGateway',
	[ERR_BAD_PAYMENT_ID]: 'enums.ReservationStatus.titles.errBadPaymentId',
	[CREATED]: 'enums.ReservationStatus.titles.created',
	[PAYMENT_METHOD_CHOSEN]: 'enums.ReservationStatus.titles.paymentMethodChosen',
	[PAID]: 'enums.ReservationStatus.titles.paid',
	[AUTHORIZED]: 'enums.ReservationStatus.titles.authorized',
	[CANCELED]: 'enums.ReservationStatus.titles.canceled',
	[TIMEOUTED]: 'enums.ReservationStatus.titles.timeouted',
	[NO_GATE]: 'enums.ReservationStatus.titles.noGate',
});

const getTitle = (status) => {
	return getTitles()[status] || 'enums.ReservationStatus.titles.unsuccessful';
};

const getSubtitles = () => ({
	[ERR_NO_SPACE]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.errNoSpace')}</span>,
	[ERR_PAYMENT_GATEWAY]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.errPaymentGateway')}</span>,
	[ERR_INVALID_DATE]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.errInvalidDate')}</span>,
	[ERR_CLOSING_TIME]: (props) => <span>{!!props.closingTime && props.translate('enums.ReservationStatus.subtitles.errClosingTime', { closingTime: props.closingTime })}</span>,
	[CREATED]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.created')}</span>,
	[PAYMENT_METHOD_CHOSEN]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.paymentMethodChosen')}</span>,
	[PAID]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.paid')}</span>,
	[AUTHORIZED]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.authorized')}</span>,
	[CANCELED]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.canceled')}</span>,
	[TIMEOUTED]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.timeouted')}</span>,
	[REFUNDED]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.refunded')}</span>,
	[PARTIALLY_REFUNDED]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.partiallyRefunded')}</span>,
	[FAILED]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.failed')}</span>,
	[NO_GATE]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles.noGate')}</span>,
});

const getSubtitle = (status) => {
	return getSubtitles()[status];
};

const getSubtitles2 = () => ({
	[ERR_PAYMENT_GATEWAY]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles2.errPaymentGateway', { phone: props.phone, email: props.email }, true)}</span>,
	[ERR_BAD_PAYMENT_ID]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles2.errBadPaymentId', { phone: props.phone, email: props.email }, true)}</span>,
	[PAYMENT_METHOD_CHOSEN]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles2.paymentMethodChosen', { phone: props.phone, email: props.email }, true)}</span>,
	[PAID]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles2.paid', { phone: props.phone, email: props.email }, true)}</span>,
	[NO_GATE]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles2.noGate', { phone: props.phone, email: props.email }, true)}</span>,
	[ERROR]: (props) => <span>{props.translate('enums.ReservationStatus.subtitles2.error', { phone: props.phone, email: props.email }, true)}</span>,
});

const getSubtitle2 = (status) => {
	return getSubtitles2()[status] || ((props) => <span>{props.translate('enums.ReservationStatus.subtitles2.general', { phone: props.phone, email: props.email }, true)}</span>);
};

const isSuccess = (status) => {
	return [
		CREATED,
		PAYMENT_METHOD_CHOSEN,
		PAID,
		AUTHORIZED,
		CANCELED,
		TIMEOUTED,
		NO_GATE,
	].includes(status);
};

export default {
	ERR_NO_SPACE,
	ERR_PAYMENT_GATEWAY,
	ERR_BAD_PAYMENT_ID,
	ERR_INVALID_DATE,
	ERR_CLOSING_TIME,

	CREATED,
	PAYMENT_METHOD_CHOSEN,
	PAID,
	AUTHORIZED,
	CANCELED,
	TIMEOUTED,
	REFUNDED,
	PARTIALLY_REFUNDED,
	FAILED,

	NO_GATE,
	ERROR,

	getTitle,
	getSubtitle,
	getSubtitle2,
	isSuccess,
};


// WEBPACK FOOTER //
// ./src/enums/ReservationStatus.js